/**
 * Localization strings for the welcome screen
 *
 * @module
 */

import { createDictionary } from './utils';

// Refer to "Guidelines for Programmers" in ./README.md before editing this file

export const welcomeText = createDictionary({
  pageTitle: {
    'en-us': 'Welcome',
    'ru-ru': 'Добро пожаловать',
    'es-es': 'Bienvenida',
    'fr-fr': 'Accueillir',
    'uk-ua': 'Ласкаво просимо',
    'de-ch': 'Willkommen',
    'pt-br': 'Bem-vindo',
    'hr-hr': 'Dobrodošli',
    nb: 'Velkommen',
  },
  aboutSpecify: {
    'en-us': 'About Specify 7',
    'ru-ru': 'О Specify 7',
    'es-es': 'Sobre Specify',
    'fr-fr': 'À propos de Spécifier 7',
    'uk-ua': 'Про Specify 7',
    'de-ch': 'Über Specify 7',
    'pt-br': 'Sobre Especificar 7',
    'hr-hr': 'O Specify 7',
    nb: 'Om Specify 7',
  },
  downloadInformation: {
    'en-us': 'Download Information',
    'ru-ru': 'Скачать информацию',
    'es-es': 'Descargar información',
    'de-ch': 'Download Information',
    'fr-fr': 'À propos de Spécifier 7',
    'uk-ua': 'Про Specify 7',
    'pt-br': 'Informações para download',
    'hr-hr': 'Preuzimanje informacija',
    nb: 'Last ned informasjon',
  },
  taxonTiles: {
    'en-us': 'Taxon Tiles',
    'ru-ru': 'Плитки таксонов',
    'es-es': 'Título Táxones',
    'fr-fr': 'Tuiles Taxons',
    'uk-ua': 'Taxon Tiles',
    'de-ch': 'Taxon-Kacheln',
    'pt-br': 'Blocos de táxon',
    'hr-hr': 'Pločice taksona',
    nb: 'Taksonkart',
  },
  taxonTilesDescription: {
    'en-us':
      'Showing Taxa with {count:number|formatted} or more {collectionObjectTable:string} records',
    'ru-ru':
      'Показаны таксоны с {count:number|formatted} или более {collectionObjectTable:string} записями',
    'es-es':
      'Mostrando taxones con {count:number|formatted} o más {collectionObjectTable:string} registros',
    'fr-fr':
      'Affichage des taxons avec des enregistrements {count:number|formatted} ou plus {collectionObjectTable:string}',
    'uk-ua':
      'Показано таксони з {count:number|formatted} або більше {collectionObjectTable:string} записів',
    'de-ch':
      'Zeigt Taxa mit {count:number|formatted} oder mehr {collectionObjectTable:string} Datensätzen',
    'pt-br':
      'Exibindo táxons com {count:number|formatted} ou mais registros {collectionObjectTable:string}',
    'hr-hr':
      'Prikazuju se taksoni s {count:number|formatted} ili više {collectionObjectTable:string} zapisa',
    nb: 'Viser taksa med {count:number|formatted} eller flere {collectionObjectTable:string} poster',
  },
  fullAddress: {
    'en-us':
      'Specify Collections Consortium <br />\n\nBiodiversity Institute <br />\n\nUniversity of Kansas <br />\n\n1345 Jayhawk Blvd. <br />\n\nLawrence, KS 66045 USA',
    'ru-ru':
      'Specify Collections Consortium <br />\n\nBiodiversity Institute <br />\n\nUniversity of Kansas <br />\n\n1345 Jayhawk Blvd. <br />\n\nLawrence, KS 66045 USA',
    'es-es':
      'Specify Collections Consortium <br />\n\nBiodiversity Institute <br />\n\nUniversity of Kansas <br />\n\n1345 Jayhawk Blvd. <br />\n\nLawrence, KS 66045 USA',
    'fr-fr':
      'Specify Collections Consortium <br />\n\nBiodiversity Institute <br />\n\nUniversity of Kansas <br />\n\n1345 Jayhawk Blvd. <br />\n\nLawrence, KS 66045 USA',
    'uk-ua':
      'Укажіть консорціум колекцій <br />\n\nІнститут біорізноманіття <br />\n\nУніверситет Канзасу <br />\n\n1345 Jayhawk Blvd. <br />\n\nЛоуренс, KS 66045 США',
    'de-ch':
      'Specify Collections Consortium <br />\n\nBiodiversity Institute <br />\n\nUniversity of Kansas <br />\n\n1345 Jayhawk Blvd. <br />\n\nLawrence, KS 66045 USA',
    'pt-br':
      'Consórcio de Coleções Específicas <br />\n\nInstituto de Biodiversidade <br />\n\nUniversidade do Kansas <br />\n\n1345 Jayhawk Blvd. <br />\n\nLawrence, KS 66045 EUA',
    'hr-hr':
      'Konzorcij za navođenje zbirki <br />\n\nInstitut za bioraznolikost <br />\n\nSveučilište u Kansasu <br />\n\n1345 Jayhawk Blvd. <br />\n\nLawrence, KS 66045 SAD',
    nb: 'Specify Collections Consortium <br />\n\nBiodiversity Institute <br />\n\nUniversity of Kansas <br />\n\n1345 Jayhawk Blvd. <br />\n\nLawrence, KS 66045 USA',
  },
  disclosure: {
    'en-us':
      'Specify is developed by the Specify Collections Consortium (SCC), a collaborative initiative governed by its members and supported by institutional partners. Software support and development are made possible by consortium members, including the UniMus:Natur Consortium of Norway, the Commonwealth Scientific and Industrial Research Organisation (CSIRO), the Consejo Superior de Investigaciones Científicas (CSIC), the Denmark Consortium of Museums, the Muséum d’Histoire Naturelle Geneva, the University of Florida, the University of Kansas, and the University of Michigan, along with numerous other member collections and institutions within the Consortium. The SCC operates under the University of Kansas Center for Research’s non-profit 501(c)(3) U.S. tax status and received support from U.S. National Science Foundation grants from 1996 to 2018.',
    'de-ch':
      'Specify wird vom Specify Collections Consortium (SCC) entwickelt, einer Kooperationsinitiative, die von ihren Mitgliedern geleitet und von institutionellen Partnern unterstützt wird. Die Softwareentwicklung und -unterstützung werden durch die Konsortiumsmitglieder ermöglicht, darunter das UniMus:Natur Consortium aus Norwegen, die Commonwealth Scientific and Industrial Research Organisation (CSIRO), der Consejo Superior de Investigaciones Científicas (CSIC), das Dänische Museumskonsortium, das Muséum d’Histoire Naturelle Genf, die University of Florida, die University of Kansas und die University of Michigan sowie zahlreiche weitere Sammlungen und Institutionen innerhalb des Konsortiums. Das SCC ist als gemeinnützige Organisation (501(c)(3)) des University of Kansas Center for Research anerkannt und wurde von 1996 bis 2018 von der U.S. National Science Foundation gefördert.',
    'es-es':
      'Specify es desarrollado por el Consorcio Specify Collections (SCC), una iniciativa colaborativa gobernada por sus miembros y respaldada por socios institucionales. El desarrollo y el soporte del software son posibles gracias a los miembros del consorcio, entre los que se incluyen el Consorcio UniMus:Natur de Noruega, la Organización de Investigación Científica e Industrial de la Commonwealth (CSIRO), el Consejo Superior de Investigaciones Científicas (CSIC), el Consorcio de Museos de Dinamarca, el Museo de Historia Natural de Ginebra, la Universidad de Florida, la Universidad de Kansas y la Universidad de Michigan, junto con numerosas otras colecciones e instituciones miembros del Consorcio. El SCC opera bajo la condición de organización sin fines de lucro 501(c)(3) del Centro de Investigación de la Universidad de Kansas y recibió apoyo de subvenciones de la Fundación Nacional de Ciencias de EE. UU. desde 1996 hasta 2018.',
    'fr-fr':
      'Specify est développé par le Specify collection consortium(SCC), une initiative collaborative gérée par ses membres et soutenue par des partenaires institutionnels. Le développement et le support logiciel sont assurés par les membres du consortium, notamment le Consortium UniMus:Natur de Norvège, l’Organisation de recherche scientifique et industrielle du Commonwealth (CSIRO), le Conseil supérieur de la recherche scientifique (CSIC), le Consortium des musées du Danemark, le Muséum d’Histoire naturelle de Genève, l’Université de Floride, l’Université du Kansas et l’Université du Michigan, ainsi que de nombreuses autres collections et institutions membres du consortium. Le SCC fonctionne sous le statut d’organisme à but non lucratif (501(c)(3)) du Centre de recherche de l’Université du Kansas et a bénéficié de subventions de la Fondation nationale américaine pour la science (NSF) de 1996 à 2018.',
    'hr-hr':
      'Specify je razvio Konzorcij za zbirke Specify (SCC), suradnička inicijativa kojom upravljaju njegovi članovi, a podržavaju je institucionalni partneri. Podršku i razvoj softvera omogućuju članovi konzorcija, uključujući UniMus:Natur konzorcij Norveške, Organizaciju za znanstvena i industrijska istraživanja Commonwealtha (CSIRO), Consejo Superior de Investigaciones Científicas (CSIC), Danski konzorcij muzeja, Muzej prirodne povijesti Ženeva, Sveučilište Florida, Sveučilište Kansas i Sveučilište Michigan, zajedno s brojnim drugim zbirkama i institucijama članicama Konzorcija. SCC djeluje pod neprofitnim poreznim statusom 501(c)(3) Sveučilišnog centra za istraživanje u Kansasu i primao je potporu od Nacionalne zaklade za znanost SAD-a od 1996. do 2018. godine.',
    nb: 'Specifice er utviklet av Specifice Collections Consortium (SCC), et samarbeidsinitiativ styrt av medlemmene og støttet av institusjonelle partnere. Programvarestøtte og -utvikling er muliggjort av konsortiummedlemmer, inkludert UniMus:Natur Consortium of Norway, Commonwealth Scientific and Industrial Research Organisation (CSIRO), Consejo Superior de Investigaciones Científicas (CSIC), Denmark Consortium of Museums, Muséum d’Histoire Naturelle Geneva, University of Florida, University of Kansas og University of Michigan, sammen med en rekke andre medlemssamlinger og institusjoner innenfor konsortiet. SCC opererer under University of Kansas Center for Researchs ideelle 501(c)(3) amerikanske skattestatus og mottok støtte fra amerikanske National Science Foundation-stipend fra 1996 til 2018.',
    'pt-br':
      'O Specify é desenvolvido pelo Specify Collections Consortium (SCC), uma iniciativa colaborativa governada por seus membros e apoiada por parceiros institucionais. O suporte e o desenvolvimento do software são viabilizados pelos membros do consórcio, incluindo o Consórcio UniMus:Natur da Noruega, a Organização de Pesquisa Científica e Industrial da Commonwealth (CSIRO), o Conselho Superior de Investigações Científicas (CSIC), o Consórcio de Museus da Dinamarca, o Museu de História Natural de Genebra, a Universidade da Flórida, a Universidade do Kansas e a Universidade de Michigan, juntamente com inúmeras outras coleções e instituições membros do Consórcio. O SCC opera sob o status de organização sem fins lucrativos 501(c)(3) do Centro de Pesquisa da Universidade do Kansas e recebeu apoio de bolsas da Fundação Nacional de Ciência dos EUA de 1996 a 2018.',
    'ru-ru':
      'Программа Specify разработана Консорциумом Specify Collections (SCC), совместной инициативой, управляемой его членами и поддерживаемой институциональными партнерами. Поддержка и разработка программного обеспечения стали возможны благодаря членам консорциума, включая консорциум UniMus:Natur из Норвегии, Организацию научных и промышленных исследований Содружества (CSIRO), Высший совет по научным исследованиям (CSIC), Датский консорциум музеев, Музей естественной истории Женевы, Университет Флориды, Университет Канзаса и Университет Мичигана, а также многочисленные другие коллекции и учреждения-члены консорциума. SCC работает в рамках некоммерческого налогового статуса 501(c)(3) Центра исследований Университета Канзаса и получал поддержку в виде грантов Национального научного фонда США с 1996 по 2018 год.',
    'uk-ua':
      'Specify розроблено Консорціумом колекцій Specify (SCC), спільною ініціативою, що керується його членами та підтримується інституційними партнерами. Підтримка та розробка програмного забезпечення здійснюється завдяки членам консорціуму, включаючи Консорціум UniMus:Natur Норвегії, Організацію наукових та промислових досліджень Співдружності (CSIRO), Вищу раду наукових досліджень (CSIC), Данський консорціум музеїв, Музей природної історії Женеви, Університет Флориди, Університет Канзасу та Університет Мічигану, а також численні інші колекції та установи-члени Консорціуму. SCC працює відповідно до некомерційного статусу Центру досліджень Канзаського університету, що підпадає під дію 501(c)(3) податкового кодексу США, та отримував підтримку від грантів Національного наукового фонду США з 1996 по 2018 рік.',
  },
  licence: {
    'en-us':
      'Specify 7, Copyright 2026, University of Kansas Center for Research. Specify comes with ABSOLUTELY NO WARRANTY. This is free, open-source software licensed under GNU General Public License v3.',
    'de-ch':
      'Specify 7, Copyright 2026, University of Kansas Center for Research. Specify wird OHNE JEGLICHE GEWÄHRLEISTUNG bereitgestellt. Dies ist freie Open-Source-Software, lizenziert unter der GNU General Public License v3.',
    'es-es':
      'Specify 7, Copyright 2026, Centro de Investigación de la Universidad de Kansas. Specify se distribuye SIN GARANTÍA ALGUNA. Este es un software libre de código abierto, licenciado bajo la Licencia Pública General GNU v3.',
    'fr-fr':
      "Specify 7, © 2026, Centre de recherche de l'Université du Kansas. Specify est fourni SANS AUCUNE GARANTIE. Il s'agit d'un logiciel libre et open source distribué sous licence GNU GPL v3.",
    'hr-hr':
      'Specify 7, Autorsko pravo 2026., Istraživački centar Sveučilišta u Kansasu. Specify dolazi APSOLUTNO BEZ JAMSTVA. Ovo je besplatni softver otvorenog koda licenciran pod GNU General Public License v3.',
    nb: 'Specificate 7, Copyright 2026, University of Kansas Center for Research. Specifice leveres UTEN GARANTI. Dette er gratis programvare med åpen kildekode lisensiert under GNU General Public License v3.',
    'pt-br':
      'Specify 7, Copyright 2026, Centro de Pesquisa da Universidade do Kansas. Specify é fornecido SEM QUALQUER GARANTIA. Este é um software livre e de código aberto licenciado sob a Licença Pública Geral GNU v3.',
    'ru-ru':
      'Specify 7, Copyright 2026, Центр исследований Канзасского университета. Программа Specify предоставляется БЕЗ КАКИХ-ЛИБО ГАРАНТИЙ. Это бесплатное программное обеспечение с открытым исходным кодом, распространяемое по лицензии GNU General Public License v3.',
    'uk-ua':
      'Specify 7, авторське право 2026, Центр досліджень Канзаського університету. Specify постачається АБСОЛЮТНО БЕЗ ГАРАНТІЇ. Це безкоштовне програмне забезпечення з відкритим кодом, ліцензоване за Загальною публічною ліцензією GNU версії 3.',
  },
  systemInformation: {
    'en-us': 'System Information',
    'ru-ru': 'Системная информация',
    'es-es': 'Información del Sistema',
    'fr-fr': 'Informations système',
    'uk-ua': 'Інформація про систему',
    'de-ch': 'Systeminformationen',
    'pt-br': 'Informações do sistema',
    'hr-hr': 'Informacije o sustavu',
    nb: 'Systeminformasjon',
  },
  specifyVersion: {
    'en-us': 'Specify 7 Version:',
    'ru-ru': 'Specify 7 Версия:',
    'es-es': 'Especifique la versión 7:',
    'fr-fr': 'Version de Specify 7 :',
    'uk-ua': 'Вкажіть 7 версію:',
    'de-ch': 'Specify 7 Version:',
    'pt-br': 'Especificar versão 7:',
    'hr-hr': 'Navedite verziju 7:',
    nb: 'Specify 7 versjon:',
  },
  gitSha: {
    'en-us': 'Git SHA:',
    'ru-ru': 'Git SHA:',
    'es-es': 'Git SHA:',
    'fr-fr': 'SHA Git :',
    'uk-ua': 'Git SHA:',
    'de-ch': 'Git SHA:',
    'pt-br': 'SHA do Git:',
    'hr-hr': 'Git SHA:',
    nb: 'Git SHA:',
  },
  buildDate: {
    'en-us': 'Build Date:',
    'ru-ru': 'Дата сборки:',
    'es-es': 'La fecha de construcción:',
    'fr-fr': 'Date de mise-en-route :',
    'uk-ua': 'Дата збірки:',
    'de-ch': 'Datum des Builds:',
    'pt-br': 'Data de compilação:',
    'hr-hr': 'Datum izrade:',
    nb: 'Versjonsdato:',
  },
  specifySixVersion: {
    'en-us': 'Specify 6 Version:',
    'ru-ru': 'Specify 6 Версия:',
    'es-es': 'Versión de Specify 6:',
    'fr-fr': 'Version de Specify 6 :',
    'uk-ua': 'Вкажіть 6 версію:',
    'de-ch': 'Specify 6 Version:',
    'pt-br': 'Especifique a versão 6:',
    'hr-hr': 'Navedite 6 verzija:',
    nb: 'Specify 6 versjon:',
  },
  databaseVersion: {
    'en-us': 'Database Version:',
    'ru-ru': 'Версия базы данных:',
    'es-es': 'Versión de la Base de Datos:',
    'fr-fr': 'Version de la base de données :',
    'uk-ua': 'Версія бази даних:',
    'de-ch': 'Datenbankversion:',
    'pt-br': 'Versão do banco de dados:',
    'hr-hr': 'Verzija baze podataka:',
    nb: 'Databaseversjon:',
  },
  schemaVersion: {
    'en-us': 'Database Schema',
    'ru-ru': 'Схема базы данных',
    'es-es': 'Esquema de la base de datos',
    'fr-fr': 'Schéma de base de données',
    'uk-ua': 'Схема бази даних',
    'de-ch': 'Datenbankschema',
    'pt-br': 'Esquema do banco de dados',
    'hr-hr': 'Shema baze podataka',
    nb: 'Databaseskjema',
  },
  databaseName: {
    'en-us': 'Database Name:',
    'ru-ru': 'Имя базы данных:',
    'es-es': 'Nombre de la Base de Datos:',
    'fr-fr': 'Nom de la base de données :',
    'uk-ua': "Ім'я бази даних:",
    'de-ch': 'Datenbank-Name:',
    'pt-br': 'Nome do banco de dados:',
    'hr-hr': 'Naziv baze podataka:',
    nb: 'Databasenavn:',
  },
  browser: {
    'en-us': 'Browser:',
    'ru-ru': 'Браузер:',
    'es-es': 'Navegador:',
    'fr-fr': 'Navigateur :',
    'uk-ua': 'Браузер:',
    'de-ch': 'Browser:',
    'pt-br': 'Navegador:',
    'hr-hr': 'Preglednik:',
    nb: 'Nettleser:',
  },
  databaseCreationDate: {
    'en-us': 'DB Creation Date:',
    'ru-ru': 'Дата создания базы данных:',
    'es-es': 'Fecha de creación de la base de datos:',
    'fr-fr': 'Date de création de la base de données :',
    'uk-ua': 'Дата створення БД:',
    'de-ch': 'Datenbank Erstelldatum:',
    'pt-br': 'Data de criação do banco de dados:',
    'hr-hr': 'Datum kreiranja baze podataka:',
    nb: 'Dato for opprettelse av database:',
  },
} as const);
